export const departments = [
    {
      id: 1,
      title: "EMERGENCY DEPARTMENT (ED)",
      icon: "fa-user-injured",
      description: "Immediate care for acute illnesses and injuries."
    },
    {
      id: 2,
      title: "INTENSIVE CARE UNIT (ICU)",
      icon: "fa-bed-pulse",
      description: "Critical care for severely ill or injured patients."
    },
    {
      id: 3,
      title: "PSYCHIATRY",
      icon: "fa-brain",
      description: "Mental health care and treatment."
    },
    {
      id: 4,
      title: "PHYSIO & REHAB",
      icon: "fa-user-doctor",
      description: "Rehabilitation and physical therapy services."
    },
    {
      id: 5,
      title: "CARDIOLOGY",
      icon: "fa-star-of-life",
      description: "Diagnosis and treatment of heart and vascular conditions."
    }
  ];

  export const services = [
    {
      id: 1,
      title: "AMBULANCE SERVICE",
      icon: "fa-truck-medical",
      description: "Fast and reliable emergency transportation to get you the care you need."
    },
    {
      id: 2,
      title: "MATERNITY CARE",
      icon: "fa-person-breastfeeding",
      description: "Comprehensive care for mothers and babies, from pregnancy to delivery."
    },
    {
      id: 3,
      title: "CHECK UP",
      icon: "fa-stethoscope",
      description: "Routine health exams to ensure your well-being and catch issues early."
    },
    {
      id: 4,
      title: "MEDICATION COLLECTION",
      icon: "fa-pills",
      description: "Convenient prescription pick-up."
    },
    {
      id: 5,
      title: "EMERGENCY CARE",
      icon: "fa-hospital",
      description: "Immediate treatment for urgent and life-threatening conditions."
    }
  ];
  
  export const FAQs = [
    {
      id: 1,
      question: "Are walk-ins accepted, or is an appointment required?",
      answer: "Walk-ins are NOT accepted, unless its a medical emergency."
    },
    {
      id: 2,
      question: "What should I bring to my first appointment?",
      answer: "Please bring your ID, insurance information, and any relevant medical records."
    },
    {
      id: 3,
      question: "What should I do in case of a medical emergency?",
      answer: "In case of a medical emergency, call 021 7402 5314 or go to your nearest emergency room."
    },
    {
      id: 4,
      question: "What payment options are available for services?",
      answer: "We are completely free of charge to the public."
    },
    {
      id: 5,
      question: "How do I obtain prescription refills from ForeverCare?",
      answer: "You can request prescription refills through our online portal or by calling the pharmacy directly."
    },
    {
      id: 6,
      question: "Do you deliver medication?",
      answer: "We do not deliver medications. Please contact the pharmacy directly for more information."
    }
  ];
  
  